import { Component } from '@angular/core';
import { SettingsPageComponent } from '../settings-page/settings-page.component';
import { PanelModule } from 'primeng/panel';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-settings-profile',
  template: `
    <p-panel header="My Profile">
      <h3>First Name: <span class="data-text">{{ currentUser?.firstName }}</span></h3>
      <h3>Last Name: <span class="data-text">{{ currentUser?.lastName }}</span></h3>
      <h3>ID: <span class="data-text">{{ currentUser?.id }}</span></h3>
      <h3>Email: <span class="data-text">{{ currentUser?.email }}</span></h3>
      <h3>Role: <span class="data-text">{{ currentUser?.role }}</span></h3>
      <div>
        <button
          pButton
          type="button"
          label="Change Password"
          class="p-button-outlined"
          [routerLink]="changePasswordPath"
        ></button>
      </div>
    </p-panel>
  `,
  styles: [`
    .data-text {
      color: #3f51b5;
    }
  `],
  standalone: true,
  imports: [PanelModule, ButtonDirective, RouterLink],
})
export class SettingsProfileComponent extends SettingsPageComponent {}
